module.exports = __webpack_public_path__ + "static/img/lo.a43eb26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lo.jpg
// module id = 57Rl
// module chunks = 0